<template>
    <div id="app" @scroll="handleScroll">
        <div class="video">
            <video ref="videoPlayer" loop autoplay class="backgroundVideo" muted playsinline>
                <source src="https://binguo.cdn.simuhunluo.top/lab/bg-light.mp4" type="video/mp4">
            </video>
        </div>
        <HeaderCom/>
        <router-view/>
        <BottomCom/>
    </div>
</template>

<script>

import HeaderCom from "@/components/HeaderCom/index.vue";
import BottomCom from "@/components/BottomCom/index.vue";

export default {
    name: 'App',
    components: {BottomCom, HeaderCom},
    methods: {
        handleScroll() {
            const scrollTop = window.scrollY;
            const el = document.querySelector('.header-container');
            if (scrollTop > 60) {
                el.style.backgroundColor = "#fff";
            } else {
                el.style.backgroundColor = "transparent";
            }
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    }
}
</script>

<style lang="scss">
@use "src/assets/css/index.scss" as *;
@import '@/assets/css/variables.scss';

#app {
    height: 100%;
    min-width: 1024px;
    overflow-y: visible; /* 确保有滚动条 */
    .video {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: -1;

        .backgroundVideo {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
}
</style>
